import { render, staticRenderFns } from "./ibc_register_info.vue?vue&type=template&id=3dcbf3ec&scoped=true&"
import script from "./ibc_register_info.vue?vue&type=script&lang=js&"
export * from "./ibc_register_info.vue?vue&type=script&lang=js&"
import style0 from "./ibc_register_info.vue?vue&type=style&index=0&id=3dcbf3ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcbf3ec",
  null
  
)

export default component.exports